import { useState } from 'react';

function usePreventWindowClose(message = 'Are you sure you want to leave this page?') {
    const [trigger, setTrigger] = useState(false);

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
        event.preventDefault();
        event.returnValue = message;

        return message;
    };

    const handleTrigger = (status: boolean, windowObject = window as Window) => {
        if (!windowObject) {
            throw new Error('Window object is not available');
        }

        setTrigger(status);

        if (status) {
            windowObject.addEventListener('beforeunload', handleBeforeUnload);
        } else {
            windowObject.removeEventListener('beforeunload', handleBeforeUnload);
        }
    };

    return {
        isPreventingClose: trigger,
        triggerClosePrevent: handleTrigger,
    };
}

export default usePreventWindowClose;
